import React, { useState } from "react";
import { IconComponent, icon } from "../../../../common/components";
import styles from "./CompaniesList.module.css";

function getCompanyHasChildren(data) {
	const result = [];
	for (const item of data) {
		if (item.children && item.children.length > 0) {
			result.push(item.id);
			result.push(...getCompanyHasChildren(item.children));
		}
	}
	return result;
}

export default function CompaniesList({
	companies = [],
	onClickRow,
	selectedCompany = null,
	selectedCompanyUserCount = null,
}) {
	const [expandedRows, setExpandedRows] = useState(getCompanyHasChildren(companies));

	const toggleRowExpansion = (companyId) => {
		if (expandedRows.includes(companyId)) {
			setExpandedRows(expandedRows.filter((id) => id !== companyId));
		} else {
			setExpandedRows([...expandedRows, companyId]);
		}
	};

	const renderCompanyRow = (company, level = 0) => {
		const isSelected = selectedCompany?.id === company.id;
		const userCount =
			isSelected && selectedCompanyUserCount !== null
				? selectedCompanyUserCount
				: company.users?.length ?? company.userCount ?? null;
		const handleActivate = () => {
			if (company.children) {
				toggleRowExpansion(company.id);
			}
			onClickRow(company);
		};
		const levelClassName = styles[`row--level-${level}`] || styles["row--level-5"];
		const rowClassName = [styles.row, levelClassName, isSelected ? styles["row--selected"] : ""]
			.filter(Boolean)
			.join(" ");
		return (
			<React.Fragment key={company.id}>
				{company.userRole === "ADMIN" && (
					<div
						className={rowClassName}
						role="button"
						tabIndex={0}
						onClick={handleActivate}
						onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && handleActivate()}
					>
						<div className={styles.rowLeft}>
							{company.children ? (
								<IconComponent
									className={styles.chevron}
									icon={expandedRows.includes(company.id) ? icon.faChevronDown : icon.faChevronRight}
									size="xs"
								/>
							) : (
								<span className={styles.chevronPlaceholder} />
							)}
							<span
								className={`${styles.label} ${isSelected ? styles["label--selected"] : ""}`}
								translate="no"
							>
								{company.shortName}
							</span>
						</div>
						{userCount !== null && (
							<div className={styles.userCount}>
								<IconComponent icon={icon.faUserFriends} size="xs" />
								<span className={styles.userCountLabel}>{userCount}</span>
							</div>
						)}
					</div>
				)}
				{company.children &&
					expandedRows.includes(company.id) &&
					company.children.map((child) => renderCompanyRow(child, level + 1))}
			</React.Fragment>
		);
	};

	return <div className={styles.list}>{companies.map((company) => renderCompanyRow(company))}</div>;
}
